type EventName = 'page_view' | 'cta_click' | 'install_click';

interface BaseProps {
  trackingId: string | null;
  [key: string]: unknown;
}

export function trackEvent(name: EventName, props: BaseProps): void {
  // dev 환경에서는 객체가 직렬화된 형태로 보이도록 JSON 으로 펼친다.
  if (import.meta.env?.DEV) {
    console.info(`[analytics] ${name} ${JSON.stringify(props)}`);
    return;
  }
  console.info('[analytics]', name, props);
}
